import * as React from 'react';

export default class HeaderLink extends React.Component<void, void> {
    render() {
        return (
            <a href="#">{this.props.children}</a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/header/HeaderLink.tsx